import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { API_BASE_URL } from '../config';

const GitHubCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get('code');
      const errorParam = searchParams.get('error');

      if (errorParam) {
        setError('GitHub authentication was cancelled or failed.');
        setTimeout(() => navigate('/login'), 3000);
        return;
      }

      if (!code) {
        setError('Invalid callback - no authorization code.');
        setTimeout(() => navigate('/login'), 3000);
        return;
      }

      try {
        // Exchange code for tokens
        const response = await axios.post(
          `${API_BASE_URL}/api/auth/oauth/github`,
          { code }
        );

        const {
          access_token,
          refresh_token,
          user_id,
          email,
          full_name,
          subscription_plan,
          is_new_user
        } = response.data;

        // Store tokens and user info
        localStorage.setItem('userEmail', email);
        if (full_name) {
          localStorage.setItem('userName', full_name);
        }

        login(access_token, refresh_token, {
          id: user_id,
          email,
          full_name,
          subscription_plan
        });

        // Redirect to original path or home
        const redirectPath = sessionStorage.getItem('oauth_redirect') || '/';
        sessionStorage.removeItem('oauth_redirect');
        navigate(redirectPath);

        if (is_new_user) {
          console.log('Welcome! New account created via GitHub.');
        }
      } catch (err) {
        console.error('GitHub OAuth error:', err);
        setError(err.response?.data?.detail || 'GitHub login failed.');
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    handleCallback();
  }, [searchParams, navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        {error ? (
          <>
            <div className="text-red-600 text-lg mb-4">{error}</div>
            <div className="text-gray-500">Redirecting to login...</div>
          </>
        ) : (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
            <div className="text-gray-700">Completing GitHub authentication...</div>
          </>
        )}
      </div>
    </div>
  );
};

export default GitHubCallback;
